module.exports = __webpack_public_path__ + "assets/img/27-l.20840eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/27-l.jpg
// module id = TKxS
// module chunks = 0